import { render } from "./BlockBuilder.vue?vue&type=template&id=fe70d5b8"
import script from "./BlockBuilder.vue?vue&type=script&lang=js"
export * from "./BlockBuilder.vue?vue&type=script&lang=js"

import "./BlockBuilder.vue?vue&type=style&index=0&id=fe70d5b8&lang=css"
script.render = render

export default script